import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

const NoRowItem = () => {

  return (
    <TableRow key={'no_items'} className="product-from-group">
      <TableCell align="right">No items</TableCell>
      <TableCell align="right">No items</TableCell>
      <TableCell align="right">No items</TableCell>
      <TableCell align="center">No items</TableCell>
      <TableCell align="center">No items</TableCell>
      <TableCell align="center">No items</TableCell>
      <TableCell align="center">No items</TableCell>
      <TableCell align="center">No items</TableCell>
    </TableRow>
  );
};

export default NoRowItem;
